/**
 * Single-flight session recovery — concurrent 401 recoveries share one refresh + select-context.
 */

import { tokenManager } from '@/utils/tokenManager'
import { performSilentReselectOnly } from '@/lib/session/silent-context-refresh'
let inFlightRecovery: Promise<boolean> | null = null

export function coordinate401SessionRecovery(options: {
  isAccessTokenInvalid: boolean
  isContextTokenInvalid: boolean
}): Promise<boolean> {
  if (!inFlightRecovery) {
    inFlightRecovery = (async () => {
      try {
        const { isAccessTokenInvalid, isContextTokenInvalid } = options
        const { authService } = await import('@/services/api/shared/auth.service')

        if (isAccessTokenInvalid) {
          try {
            await authService.refreshToken()
          } catch {
            return false
          }
        }

        if (isContextTokenInvalid) {
          tokenManager.removeToken('contextToken')
        }

        const result = await performSilentReselectOnly()
        return result.success
      } catch {
        return false
      } finally {
        inFlightRecovery = null
      }
    })()
  }
  return inFlightRecovery
}

export function invalidateRecoveryQueueForContextSwitch(): void {
  inFlightRecovery = null
}
